import { createSlice } from '@reduxjs/toolkit';

type orderingPrinterState = {
  printerSetting: boolean;
};

const initialState: orderingPrinterState = {
  printerSetting: true,
};

export const orderingPrinterSlice = createSlice({
  name: 'orderingPrinterSlice',
  initialState,
  reducers: {
    changePrinterSetting: (state, action) => ({
      printerSetting: action.payload,
    }),
  },
});
